const state = {
  TextDSGVO: "",
  TextStartseite: "",
  NavigationDrawer: false,
  Show_Navigation: true,
  Weapon_Transfer_Search: [],
  websocket_online: false,
  loading: false,
  backendReachable: true
};

export default state;
